import { render, staticRenderFns } from "./DialogMotivoCancelamento.vue?vue&type=template&id=13e4d322"
import script from "./DialogMotivoCancelamento.vue?vue&type=script&lang=js"
export * from "./DialogMotivoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports